class Phone {
    static init() {
        [...document.querySelectorAll("[data-phone]")].forEach(phone => phone.addEventListener("click", () => phone.innerHTML = phone.dataset.phone));
    }
}

export default Phone;


// WEBPACK FOOTER //
// ./src/scripts/components/phone.js